import React, { useState, useEffect } from "react";
import {useLocation} from "react-router-dom";
import styles from "./styles.module.scss";
import { MdArrowDropDown } from "react-icons/md";
import ProfileCard from "./ProfileCard";
import { useSelector } from "react-redux";
import axios from "axios";
import { adminToken } from "helper";
import Newsubmsg from "./Newsubmsg";
import NotAcceptRouteMsg from "./NotAcceptRouteMsg";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";



const Navbar = () => {
  const {pathname} = useLocation();
  const [drop, setDrop] = useState(false);
  const [newsubmsg, setNewsubmsg] = useState('');
  const [newsubcount, setNewsubcount] = useState(0);
  const [duration, setDuration] = useState(0);
  const user = useSelector(state => state.user);
  const [notaccerou, setNotaccerou] = useState('');
  const [notarcount, setNotarcount] = useState(0);

  const toggle = () => setDrop(!drop);

  useEffect(() => {
    setInterval(newsubcheck, 30000);
    //newsubcheck();
    notacceptroutes();
  }, []);

  const  newsubcheck =  () => {
    adminToken().then(token => axios
      .get(
          `${AWS_SERVER_APIS}/getneworders`,
          {
              headers: {
                  Authorization: `Bearer ${token}`
              }
          }
      )
      .then(res => {
        setNewsubmsg(res.data.message);
        setNewsubcount(res.data.count);
        setDuration(res.data.db_sec);
      })
      .catch(err => console.log(err))
  )
  }

  const  notacceptroutes =  () => {
    adminToken().then(token => axios
      .get(
          `${AWS_SERVER_APIS}/getnotacceptroutes`,
          {
              headers: {
                  Authorization: `Bearer ${token}`
              }
          }
      )
      .then(res => {
        setNotaccerou(res.data.message);
        setNotarcount(res.data.count);
      })
      .catch(err => console.log(err))
  )
  }

  return (
    <div className={styles.navbar}>
      <div className={styles.newsubmain}>
        <Newsubmsg newsubmsg={newsubmsg} newsubcount={newsubcount} duration={duration}/>
      </div>
      <div className={styles.notacceptroute}>
        {(pathname != '/grand-app-behaviour')?<NotAcceptRouteMsg notaccerou={notaccerou} notarcount={notarcount}/>:''}
      </div>
      <div className={styles.dropdown} onClick={toggle}>
       <p>{`${user?.first_name || "John"} ${user?.last_name || ""}`}</p>
        <MdArrowDropDown size="20" />
      </div>

      {drop && <ProfileCard />}
    </div>
  );
};

export default Navbar;
